'use strict';

angular.module('ecrd.queries')
    .controller('queriesListOpenController', ['$log', 'ShareCrfApiErrorCodes', 'QueriesListUtilities', 'TableItems', 'gettextCatalog', 'CrdConfigurationService', function($log, ShareCrfApiErrorCodes, QueriesListUtilities, TableItems, gettextCatalog, CrdConfigurationService) {
        var vm = this;

        vm.error = false;

        vm.queries = [];
        vm.labelSingular = CrdConfigurationService.getLabelSingular();

        vm.table = {
            loading: true,
            error: false,
            count: 0,
            offset: 0,
            limit: TableItems.getSelectedOption('queries'),
            currentPage: 0,
            orderBy: 'daysSinceLastUpdate',
            orderReverse: true,
            filters: {
                recordUid: '',
                siteCode: undefined,
                type: '',
                status: 'open',
                substatus: '',
                creatorName: '',
                inSite: '',
                text: '',
                field: null,
            },
        };

        vm.listQueries = function() {
            vm.table.loading = true;
            vm.table.error = false;

            var params = QueriesListUtilities.parseTableSettings(vm.table);

            return QueriesListUtilities.list(params)
                .then(function(queriesData) {
                    vm.queries = queriesData.rows;
                    vm.table.count = queriesData.count;

                    vm.table.loading = false;
                })
                .catch(function(error) {
                    $log.error(error, 'get open queries');
                    vm.error = ShareCrfApiErrorCodes.getHumanReadableMessage(error);

                    vm.table.loading = false;
                    vm.table.error = true;
                });
        };

        vm.fieldSelectorVisible = false;
        vm.openFieldSelector = function() {
            vm.fieldSelectorVisible = true;
        };
        vm.closeFieldSelector = function() {
            vm.fieldSelectorVisible = false;
        };
        vm.toogleFieldSelector = function() {
            vm.fieldSelectorVisible = !vm.fieldSelectorVisible;
        };
        vm.clearFieldSelector = function() {
            vm.table.filters.field = null;
            vm.closeFieldSelector();
            vm.listQueries();
        };
        vm.selectField = function(field) {
            vm.table.filters.field = field;
            vm.closeFieldSelector();
            vm.listQueries();
        };

        vm.redirectToRecord = function(recordId, fieldUId) {
            vm.main.redirectToRecord({
                recordId: recordId,
                target: fieldUId,
            });
        };

        vm.getQuerySummary = QueriesListUtilities.buildSummary;

        /**
         * Traduce el código interno de estado de una query en un texto legible
         *
         * @param  {string} status Estado: new, updated, closed, ...
         *
         * @return {string}        Estado legible
         */
        vm.getQueryStatus = function getQueryStatus(status) {
            switch (status) {
                case 'new':
                    return gettextCatalog.getString('Nueva');
                case 'updated':
                    return gettextCatalog.getString('Actualizada');
                case 'resolution_proposed':
                    return gettextCatalog.getString('Resolución propuesta');
                case 'closed':
                    return gettextCatalog.getString('Cerrada');
                default:
                    return status;
            }
        };

        vm.downloading = false;
        vm.downloadExcel = function() {
            vm.downloading = true;
            vm.error = false;

            var columns = [
                {
                    id: 'recordUid',
                    header: CrdConfigurationService.getLabelSingular(),
                    type: 'string',
                },
                {
                    id: 'fieldLabel',
                    header: gettextCatalog.getString('Campo'),
                    formatter: function(value) {
                        return value.join(' / ');
                    },
                    type: 'string',
                },
                {
                    id: 'text',
                    header: gettextCatalog.getString('Descripción'),
                    formatter: QueriesListUtilities.buildFullSummary,
                    type: 'string',
                },
                {
                    id: 'creatorFullname',
                    header: gettextCatalog.getString('Started By'),
                    type: 'string',
                },
                {
                    id: 'fieldValue',
                    header: gettextCatalog.getString('Valor'),
                    formatter: QueriesListUtilities.formatValue,
                    type: 'string',
                },
                {
                    id: 'status',
                    header: gettextCatalog.getString('Estado'),
                    formatter: vm.getQueryStatus,
                    type: 'string',
                },
                {
                    id: 'daysSinceOpened',
                    header: gettextCatalog.getString('Días abierta'),
                    type: 'number',
                },
                {
                    id: 'daysSinceLastUpdate',
                    header: gettextCatalog.getString('Días desde la última respuesta'),
                    type: 'number',
                },
            ];
            var title = gettextCatalog.getString('Notas de discrepancia abiertas');

            return QueriesListUtilities.downloadExcel(vm.table, columns, title)
                .catch(function(error) {
                    $log.error(error);
                    vm.error = ShareCrfApiErrorCodes.getHumanReadableMessage(error);
                })
                .finally(function() {
                    vm.downloading = false;
                });
        };

        vm.getFieldType = QueriesListUtilities.getFieldType;
    }]);
